import { useEffect } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import YoutubeLive from '@/components/YoutubeLive';
import ToTopIcon from '@/components/UI/svg/Icons/ToTopIcon';

const liveBgMap = {
    us: '/media/product-smart/live-bg-en.png',
    ca: '/media/product-smart/live-bg-en.png',
    de: '/media/product-smart/live-bg-de.png',
    default: '/media/product-smart/live-bg-default.jpg',
    mobile: {
        us: '/media/product-smart/h5/live-bg-en.png',
        ca: '/media/product-smart/h5/live-bg-en.png',
        de: '/media/product-smart/h5/live-bg-de.png',
    },
};

export default function D() {
    const { isMobile, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('smartdevices');
    const { t: s } = useLang('shared');
    const { locale } = useRouter();

    const isShow = locale !== 'us' && locale !== 'ca';
    const goNowLink = `https://${locale}.ecoflow.com/pages/smart-devices-wishlist`;
    const currentImg = (isMobile ? liveBgMap.mobile[locale] : liveBgMap[locale]) || liveBgMap.default;

    const toTop = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_preview_page',
            button_name: 'Back to top',
            list_name: 'none',
        });
        const targetEl = document.querySelector('.devices-B .devices-b-h') as HTMLDivElement;
        const top = targetEl ? (isMobile ? targetEl?.offsetTop + 260 : targetEl?.offsetTop) : 0;
        window?.scrollTo({
            top,
        });
    };

    const getDataLayer = (type: string, list_name: string) => {
        return {
            event: 'uaEvent',
            event_name: 'product_preview_page',
            button_name: type,
            list_name,
        };
    };
    useEffect(() => {
        // 父组件会隐藏B组件，导致动画计算出问题，使用setTimeout规避下
        setTimeout(() => {
            AniContainer.create({
                asyncFromTo: [
                    ['.devices-D .devicesd-h1', { opacity: 0, ease: 'linear' }, { opacity: 1 }],
                    ['.devices-D .devicesd-ms1', { opacity: 0, ease: 'linear' }, { opacity: 1 }],
                    ['.devices-D .devicesd-video', { opacity: 0, ease: 'linear' }, { opacity: 1 }],
                ],
                triggerElement: '.devices-D',
                triggerHook: 1,
                offset: '20%',
                duration: 200,
            });
        }, 30);
    }, []);

    const goNowBox = isMobile ? (
        <div className="go-now-box">
            <div className="img-box">
                <NextImage
                    webpSrc={require('@publicLocal/smart-devices-teaser/h5/dream-product.webp')}
                    src={require('@publicLocal/smart-devices-teaser/h5/dream-product.png')}
                />
            </div>
            <div className="go-now-content">
                <div className="go-now-title">{t('teaser.smartdMsB1')}</div>
                <div className="go-now-desc">{t('teaser.smartdMsB2')}</div>
                <Link target="_blank" href={goNowLink}>
                    <div className="go-now-btn">{t('teaser.smartdMsB3')}</div>
                </Link>
            </div>
        </div>
    ) : (
        <div className="devicesd-a-box">
            <NextImage
                webpSrc={require('@publicLocal/smart-devices-teaser/pc/wish_act.webp')}
                src={require('@publicLocal/smart-devices-teaser/pc/wish_act.png')}
            />
            <div className="devicesd-a-r">
                <div className="devicesd-a-ms1">{t('teaser.smartdMsB1')}</div>
                <div className="devicesd-a-ms2">{t('teaser.smartdMsB2')}</div>
                <div className="devicesd-a-ms3">
                    <Link target="_blank" href={goNowLink} dataLayer={getDataLayer(t('teaser.smartdMsB3'), t('teaser.smartdMsB1'))}>
                        <div className="devicesd-a-btn">{t('teaser.smartdMsB3')}</div>
                    </Link>
                </div>
            </div>
        </div>
    );

    useEffect(() => {
        // 动画--组件B
        AniContainer.create({
            asyncFromTo: [
                ['.devices-D .devicesd-h1', { opacity: 0, ease: 'linear' }, { opacity: 1 }],
                ['.devices-D .devicesd-ms1', { opacity: 0, ease: 'linear' }, { opacity: 1 }],
                ['.devices-D .devicesd-video', { opacity: 0, ease: 'linear' }, { opacity: 1 }],
            ],
            triggerElement: '.devices-D',
            triggerHook: 1,
            offset: '20%',
            duration: 200,
        });
    }, []);

    return (
        <div className={`devices-D ${css.devicesD} ${isMobile ? 'devices-D-h5' : 'devices-D-pc'}`}>
            <div className="devicesd-h1">{t('teaser.smartdMsA1')}</div>
            <div className="devicesd-ms1">
                {t('teaser.smartdMsA2')}
                <div className="devicesd-color1"> {t('teaser.smartdMsA3')}</div>
            </div>
            <div className="devicesd-video">
                <YoutubeLive img={currentImg} />
            </div>
            {isShow && goNowBox}
            <div className="devicesd-btn-box" onClick={toTop}>
                <span className="to-top-text">{s('backToTop')}</span>
                <ToTopIcon className="to-top-icon" fill="#000" size={isMobile ? '16' : '24'} />
            </div>
        </div>
    );
}
